module.exports = __webpack_public_path__ + "img/jhsld.e9af001f.jpg";